import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

import { CopyLinkComponent } from './components/copy-link/copy-link.component';

import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@shared/modules/tooltip/tooltip.module';

@NgModule({
  declarations: [
    CopyLinkComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    IonicModule,
    TooltipModule
  ],
  exports: [
    CopyLinkComponent
  ],
})
export class CopyLinkModule {}
